import {createFileRoute} from "@tanstack/react-router";
import {getOfferTemplateQueryOptions} from "@project/application/sales/offer-templates";
import {offerEditorWorkspaceMessages} from "@project/components/semantic-adapters/sales/offers/offer-editor-workspace.messages";
import {OfferTemplateEditorPage} from "./-page/offer-template-editor.page";
import {OfferTemplateEditorPending} from "./-page/offer-template-editor.pending";

export const Route = createFileRoute("/_app/sales/offers/templates/editor/$offerTemplateId/")({
  component: RouteComponent,
  loader: ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getOfferTemplateQueryOptions(params.offerTemplateId)),
  pendingComponent: OfferTemplateEditorPending,
  staticData: {
    meta: {
      labelDescriptor: offerEditorWorkspaceMessages.editor,
      breadcrumbs: {
        getParent: (params, data) =>
          data &&
          typeof data === "object" &&
          "offerTemplateId" in data &&
          typeof data.offerTemplateId === "string" &&
          data.offerTemplateId.toLowerCase() === params.offerTemplateId?.toLowerCase() &&
          "name" in data &&
          typeof data.name === "string"
            ? {
                label: data.name,
                pathname: "/sales/offers/templates/" + encodeURIComponent(data.offerTemplateId),
              }
            : null,
      },
    },
  },
});
function RouteComponent() {
  const {offerTemplateId} = Route.useParams();
  return <OfferTemplateEditorPage offerTemplateId={offerTemplateId} />;
}
